import "../assets/App.css";
//import bottleSplash from "../assets/bottleSplash.png";
import { Button } from "react-bootstrap";
import NavBar from "../Components/NavBar";

export const Home = () => {
  return (
    <div className="home">
      <NavBar />
      <div className="splash">
        <div className="splash-text">
          <div className="drift-text-container">
            <h1 className="drift-text"> Drift </h1>
          </div>

          <div className="drift-button-container">
            <a href={"/Draft"} className="drift-button">shift your drift</a>
          </div>
        </div>
      </div>
    </div>);
};

export default Home;
